import ExpandMore from "@mui/icons-material/ExpandMore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Collapse from "@mui/material/Collapse";
import { useCustomViewDialogStore } from "csi/middleware/customView/CustomViewDialogStore";
import { Box, FlexColumn, FlexRowCenter, OverflowText } from "designSystem/index";
import { black } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent, ReactNode } from "react";

interface CustomViewOptionCustomSectionProps {
	/** children component rendering within this custom section */
    children: ReactNode;

	/** indicate collapsed or expanded state of the section header */
	collapsed: boolean;

	/** data-csi-automation value */
	dataCsiAutomation?: string;

	/** title label of the section header */
	titleRes: string;

	/** function to toggle the collapsed/expanded state */
	onCollapse: () => void;
}

const CustomViewOptionCustomSection: FunctionComponent<CustomViewOptionCustomSectionProps> = observer((props) => {
	const { dataCsiAutomation, children, collapsed, titleRes, onCollapse } = props;
	const { STANDARD_PADDING } = useCustomViewDialogStore();
	const csiAutomation = dataCsiAutomation ? { "data-csi-automation" : dataCsiAutomation } : {};

	return (
		<>
			<FlexRowCenter
				aria-label={collapsed ? "expand" : "collapse"}
				borderBottom={collapsed ? STANDARD_BORDER_STYLE : "0px"}
				onClick={onCollapse}
				sx={{
					padding: "12px 16px 12px 20px",
				}}
			>
				<Box>
					{collapsed ?
						<KeyboardArrowRightIcon sx={{ color: black[100] }} /> 
						:
						<ExpandMore sx={{ color: black[100] }} /> }
				</Box>
				<OverflowText
					bold
					fontSize={14}
					lineHeight={20}
					res={titleRes}
				/>
			</FlexRowCenter>
			<FlexColumn
				borderBottom={!collapsed ? STANDARD_BORDER_STYLE : 0}
				{...csiAutomation}
				padding={!collapsed ? STANDARD_PADDING : 0}
				sx={{ height: "auto" }}
			>
				<Collapse in={!collapsed} timeout="auto">
					{children}
				</Collapse>
			</FlexColumn>
		</>
	);
});

export default CustomViewOptionCustomSection;